import { useState } from 'react';
import { Modal } from '@/components/widgets/modal';
import { Header } from './components/survey-form-header';
import { DialogLeave } from './components/dialog-leave/dialog-leave';
import { HeaderBanner } from './components/header-banner';
import { SurveyForm } from './components/survey-form';

interface SurveyMainProps {
	showSurveyForm : boolean;
	setShowSurveyForm: (showSurveyForm: boolean) => void;
}
export const SurveyMain = ({ showSurveyForm, setShowSurveyForm }: SurveyMainProps) => {
	const [showLeaveDialog, setShowLeaveDialog] = useState(false);
	const [feedbackRecord, setFeedbackRecord] = useState('');
	
	const handleCloseForm = () => {
		localStorage.setItem('player-survey-data', feedbackRecord);
		setShowSurveyForm(false)
	}

	const handleShowLeaveDialog = () => {
		setShowLeaveDialog(!showLeaveDialog)
	}
	
	return (
		<Modal
			variant="top"
			isOpen={ showSurveyForm }
			closeModal={handleCloseForm}
			showHeader={false}
			isBackdropClose={false}
		>
			<div className="survey-main" data-open={showSurveyForm}>
				<Header 
					clickClose={handleShowLeaveDialog} 
				/>
				<div className="survey-scroller">
					<HeaderBanner />
					<SurveyForm 
						setFeedbackRecord={setFeedbackRecord}
						setShowSurveyForm={setShowSurveyForm} 
					/>
				</div>
				<DialogLeave 
					isShow={showLeaveDialog}
					closeForm={handleCloseForm} 
					closeDialog={handleShowLeaveDialog}
				/>
			</div>
		</Modal>
	)
}